import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex justify-center"
}

import { computed, PropType, ref, Ref } from 'vue';
import { useRouter } from 'vue-router';
import { uniq } from 'lodash';

import { ITEM_PER_PAGE } from '@/services';
import { useGetDevicesQuery } from '@/entities/device/hooks';
import { useGetInspectionsQuery } from '@/entities/inspection/hooks';

import { Device } from '@/entities/device/types';
import { Inspection } from '@/entities/inspection/types';

import { NkTable, NkTableColumn, NkButton } from '@/core/components';



export default /*#__PURE__*/_defineComponent({
  __name: 'InspectionTable',
  props: {
  inspectionIds: {
    type: Array as PropType<Inspection[]>,
    default: () => ([]),
  },
  isVolta: {
    type: Boolean,
    default: false,
  }
},
  setup(__props) {

const props = __props



const router = useRouter();

const canFetchMore = ref(false);
const page = ref(1);

const hasInspectionIds = computed(() => !!props.inspectionIds?.length);
const inspectionsQueryFilters: Ref = computed(() => ({
  ids: [...props.inspectionIds],
  page: page.value,
}));

const { data: inspections, isLoading, refetch } = useGetInspectionsQuery({
  enabled: hasInspectionIds,
  keepPreviousData: true,
  onSuccess: (data) => {
    canFetchMore.value = data.length >= ITEM_PER_PAGE;
  },
}, inspectionsQueryFilters);

const deviceIds = computed(() => uniq(inspections.value?.map(o => o.device)));
const hasDevicesIds = computed(() => !!deviceIds.value.length);
const devicesQueryFilters = computed(() => ({
  ids: [...deviceIds.value],
}));
const { data: devices } = useGetDevicesQuery({
  enabled: hasDevicesIds,
}, devicesQueryFilters);

const getDevice = (deviceId: Device['id']) => devices.value?.find(d => d.id === deviceId);
const getDeviceName = (deviceId: Device['id']) => getDevice(deviceId)?.deviceValues.find(o => o.reference === 'name')?.value || '-';

const fetchMore = () => {
  if (!isLoading.value) {
    page.value += 1;
    refetch.value();
  }
}

const handleRowClick = (inspection: Inspection) => {
  router.push({
    name: 'visionair-inspection',
    params: {
      inspection: inspection.id,
    },
  });
};

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_unref(NkTable), {
        data: _unref(inspections),
        onRowClick: handleRowClick,
        clickable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NkTableColumn), {
            label: _ctx.$t('misc.device')
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(getDeviceName(scope.row.device)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          (!props.isVolta)
            ? (_openBlock(), _createBlock(_unref(NkTableColumn), {
                key: 0,
                label: _ctx.$t('misc.annotations')
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row?.annotations?.length || 0), 1)
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (props.isVolta)
            ? (_openBlock(), _createBlock(_unref(NkTableColumn), {
                key: 1,
                label: _ctx.$t('misc.volta_measure')
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row?.voltaMeasures?.length || 0), 1)
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(NkTableColumn), {
            label: _ctx.$t('misc.date')
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.$format(scope.row?.date)), 1)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    (canFetchMore.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _withDirectives((_openBlock(), _createBlock(_unref(NkButton), { onClick: fetchMore }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('actions.see_more')), 1)
            ]),
            _: 1
          })), [
            [_directive_loading, _unref(isLoading)]
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})